import { ActivityAddress } from '../models/activityAddress';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { IActivityAddress, IWalklistLDPS } from '../interfaces/models';
import {
  CentralApis,
  Endpoint,
  PAGES,
  PageConfig,
} from '../interfaces/internal';
import { Page } from './page';
import { WalklistLDPS } from '../models/walklist';
import { Result, IPage } from '../interfaces/helpers';
import { Inject } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { IK2ViewInteraction } from '../models/K2ViewInteraction.model';
import { formatAddressName } from '../lib/utils';

export class WalklistLPDSPage extends Page<WalklistLDPS> {
  private header;

  constructor(
    @Inject(ENV) env: IEnvironment,
    { endpoint }: Endpoint,
    config: PageConfig,
    private k2view: IPage<IK2ViewInteraction>
  ) {
    super(
      (endpoint as CentralApis).activity + 'address',
      PAGES.WALKLISTLPDS,
      config
    );

    this.header = env.api.headers.k2view;

    this.initializeColumns({
      keys: new WalklistLDPS(),
      editableFields: this.editableFields,
      dropdownFields: this.dropdownFields,
      hiddenTableFields: ['checked', 'searchStreet'],
    });
  }

  get actions(): string[] {
    return [];
  }

  get editableFields(): string[] {
    return ['walklistActive', 'walklistDescription', 'vendorSalesRep'];
  }

  get dropdownFields(): string[] {
    return ['vendorSalesRep'];
  }

  update(item: IWalklistLDPS): Observable<WalklistLDPS> {
    throw new Error('Method not implemented.');
  }
  fetchById(id: string): Observable<WalklistLDPS> {
    throw new Error('Method not implemented.');
  }

  fetch(queryParams?, condition?): Observable<Result<WalklistLDPS>> {
    /*if (condition && condition.condition.indexOf('vendorGroupsById') !== -1) {
      queryParams = {...queryParams,  vendorGroups: condition.value?.toString()};
    }*/

    return this.getItems<Result<ActivityAddress>>(
      queryParams,
      this.header
    ).pipe(
      take(1),
      switchMap((result: any) => {
        const items = result.items;

        let ids = items.map((i) => i.addressId);
        ids = ids.filter((x) => x !== undefined && x !== 'undefined');

        return this.k2view.fetch({
          addressId: ids.join(),
        });
      }),
      map((addressResult) => {
        const items: WalklistLDPS[] = addressResult.items.map((add) => {
          const fsa = add.characteristic
            ? add.characteristic.fibreServingArea
            : '';

          const premiseType = add.characteristic
            ? add.characteristic.premiseType
            : '';

          const address = add.address;
          let serviceAddress = '';
          if (address) {
            if (address.streetName) {
              serviceAddress = `${serviceAddress} ${address.streetName}`;
            }
            if (address.streetTypeSuffix) {
              serviceAddress = `${serviceAddress} ${address.streetTypeSuffix}`;
            }
            if (address.city) {
              serviceAddress = `${serviceAddress} ${address.city}`;
            }
            if (address.postalCode) {
              serviceAddress = `${serviceAddress} ${address.postalCode}`;
            }
          }

          return new WalklistLDPS({
            id: '',
            serviceAddress,
            premiseType,
            lpds: add.addressId,
            fsa,
          });
        });

        return {
          items,
          meta: addressResult.meta,
          links: addressResult.links,
        };
      })
    );
  }

  fetchByAddressIds(ids: string[]): Observable<Result<WalklistLDPS>> {
    return this.k2view
      .fetch({
        addressId: ids.join(),
      })
      .pipe(
        take(1),
        map((addressResult) => {
          const items: WalklistLDPS[] = [];
          for (const key in addressResult.items) {
            if (addressResult.items.hasOwnProperty(key)) {
              const newItem = new WalklistLDPS();
              newItem.fsa = addressResult.items[key].characteristic
                ? addressResult.items[key].characteristic.fibreServingArea
                : '';
              newItem.id = '';
              newItem.lpds = addressResult.items[key].addressId;
              newItem.premiseType = addressResult.items[key].characteristic
                ? addressResult.items[key].characteristic.premiseType
                : '';

              newItem.serviceAddress = formatAddressName(
                addressResult.items[key].address
              );

              items.push(newItem);
            }
          }

          return {
            items,
            meta: null,
            links: null,
          };
        })
      );
  }

  createFromDTO(item): WalklistLDPS {
    return item;
  }
}
